export default function RidePreviewModal({ open, url, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60">
      <div className="bg-white w-[90%] h-[90%] rounded-lg shadow-xl relative">

        {/* HEADER */}
        <div className="flex justify-between items-center px-4 py-2 border-b">
          <span className="font-semibold text-gray-700">
            Vista previa – RIDE
          </span>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-600 text-xl"
          >
            ✕
          </button>
        </div>

        {/* VISOR PDF */}
        <iframe
          src={url}
          title="RIDE PDF"
          className="w-full h-full rounded-b-lg"
        />
      </div>
    </div>
  );
}
